export default __webpack_public_path__ + "images/p686-logo.5895e88ebd871addeb355e8b36266c18.png";